module.exports = __webpack_public_path__ + "static/img/biaoti.2326d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/biaoti.png
// module id = F/C+
// module chunks = 1